import {Injectable, Inject} from '@angular/core';
import {Http, Headers, Response, RequestOptions} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()
export class UserService {
    constructor(private http: Http, @Inject(APP_CONFIG) private config: IAppConfig) { }
    signup(
        email: string,
        password: string,
        confirm_password: string,
        firstname: string,
        lastname: string,
        username: string
    ) {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const body = JSON.stringify({
             'email': email ,
             'password': password ,
             'confirm_password': confirm_password ,
             'firstname': firstname ,
             'lastname': lastname ,
             'username': username
        });
        return this.http.post(this.config.apiEndpoint + 'user/sign-up', body, {headers: headers})
            .map(
                (res: Response) => {
                    const result = res.json();
                    return result;
                }
            )
            .catch(this.handleErrorObservable);
    }


    socialSignup(
        email: string,
        password: string,
        confirm_password: string,
        firstname: string,
        lastname: string,
        username: string
    ) {
        const headers = new Headers({ 'Content-Type': 'application/json' });
        const body = JSON.stringify({
             'email': email ,
             'password': password ,
             'confirm_password': confirm_password ,
             'firstname': firstname ,
             'lastname': lastname ,
             'username': username
        });
        return this.http.post(this.config.apiEndpoint + 'user/social-sign-up', body, {headers: headers})
            .map(
                (res: Response) => {
                    const result = res.json();
                    return result;
                }
            )
            .catch(this.handleErrorObservable);
    }

    private handleErrorObservable (error: Response | any) {
        /* if(!error.json().error){
          alert('Please check your internet connection');
        } */
        return Observable.throw( error.json().error || error.json() || 'Server Error' );
    }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/user.service.ts